// @flow

export const LIB_NAME = 'trix-web-lib-core-entities';
